import React, {useEffect, useState, useRef} from "react";
import ProtectedRoute from '../../routes/protected';
import useUserData from "../../context/user";
import useCompanyData from "../../context/company";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro'
import { Toast } from 'primereact/toast';
import carreiras from '../../assets/images/icons/carreiras.png'
import configs from '../../assets/images/icons/configs.png'
import metas from '../../assets/images/icons/metas.png'
import performance from '../../assets/images/icons/performance.png'
import indicadores from '../../assets/images/icons/indicadores.png'
import cargosSalarios from '../../assets/images/icons/cargos_e_salarios.png'
import recrutamento from '../../assets/images/icons/recrutamento.png'
import admissao from '../../assets/images/icons/admissao.png'
import organograma from '../../assets/images/icons/organograma.png'
import pesquisas from '../../assets/images/icons/pesquisas.png'
import birthdays from '../../assets/images/icons/birthdays.png'
import CompanyLogoDefault from '../../assets/images/company-logo-default.png'
import UsePerms from "../../context/userAccess";
import companyService from "../../services/data/company.service";
import moment from "moment";
import 'moment/locale/pt-br'
import { useNavigate } from 'react-router-dom';
import http from '../../services/http';
import employeeService from '../../services/data/employee.service';
import careerService from '../../services/data/career.service';
import surveyService from '../../services/data/survey.service';
import birthdayService from '../../services/data/birthday.service';
import companyAnniversaryService from '../../services/data/company-anniversary.service';
import performanceService from '../../services/data/performance.service';


export default function Painel() {

    const VerifyPerms = UsePerms()
    const {user} = useUserData()
    const navigate = useNavigate()
    const {company, updateCompany, rootUser, _userPosition, canAccess} = useCompanyData()
    const [isManager, setIsManager] = useState(false)
    const [messageList, setMessageList] = useState('')
    const [messageCount, setMessageCount] = useState(0)
    const [userEmployee, setUserEmployee] = useState('')
    const [pendingTransfers, setPendingTransfers] = useState([])
    const [pendingTransfersCount, setPendingTransfersCount] = useState(0)
    const [pendingSurveysCount, setPendingSurveysCount] = useState(0)
    const [upcomingBirthdays, setUpcomingBirthdays] = useState([])
    const [upcomingAnniversaries, setUpcomingAnniversaries] = useState([])
    const [pendingPerformanceSteps, setPendingPerformanceSteps] = useState([])
    const toast = useRef(null)

    useEffect(() => {

        if (!company) {
            updateCompany()
        }
        
    }, []);

    useEffect(() => {

        if (user) {
            listMessages()
        }

    }, [user])

    useEffect(() => {

        if (user) {
            getEmployee()
        }
    }, [])

    useEffect(() => {

        // verifica se o user tem subordinados para poder acessar "Minha Equipe" nos módulos
        if (userEmployee && userEmployee.childrenCount > 0) {
            setIsManager(true)
        }

        if (rootUser) {
            setIsManager(true)
        }

    }, [userEmployee]);

    useEffect(() => {
        if (userEmployee) {
            loadPendingTransfers()
        }
    }, [userEmployee]);

    useEffect(() => {
        const companyId = localStorage.getItem('companyId')
        if (companyId) {
            surveyService.getPendingSurveys({ company_id: companyId })
                .then(r => setPendingSurveysCount((r || []).length))
                .catch(() => {})
        }
    }, []);

    useEffect(() => {
        const companyId = localStorage.getItem('companyId')
        if (companyId) {
            birthdayService.getUpcoming({ company_id: companyId, days: 7 })
                .then(r => setUpcomingBirthdays(r || []))
                .catch(() => {})
        }
    }, []);

    useEffect(() => {
        const companyId = localStorage.getItem('companyId')
        if (companyId) {
            companyAnniversaryService.getUpcoming({ company_id: companyId, days: 7 })
                .then(r => setUpcomingAnniversaries(r || []))
                .catch(() => {})
        }
    }, []);

    useEffect(() => {
        const companyId = localStorage.getItem('companyId')
        if (companyId) {
            performanceService.getMyPendingSteps({ company_id: companyId })
                .then(r => setPendingPerformanceSteps(r || []))
                .catch(() => {})
        }
    }, []);

    function loadPendingTransfers() {
        const companyId = localStorage.getItem('companyId')
        if (!companyId) return
        careerService.listPendingTransfers(1, { company_id: companyId })
            .then(r => {
                setPendingTransfers(r.results || [])
                setPendingTransfersCount(r.count || 0)
            })
            .catch(() => {})
    }

    function getEmployee() {
        employeeService.getUserEmployee().then((response) => {
            setUserEmployee(response)
        }).catch((error) => {
            console.log(error.response)
        });
    }

    function listMessages() {

        let data = {
            recipient__uid: user.uid
        }
        companyService.listMessage(data).then((response) => {
            setMessageList(response)
            setMessageCount(response.count)
        }).catch((error) => {
            console.log(error.response)
        });
    }

    function seeMessage(item) {
        return navigate(`/messages/inbox/`, {state: {currentItem: item}})
    }

    async function redirectToRecruitment() {
        try {
            const response = await http.get(`${process.env.REACT_APP_BASE_URL}auth/ats/login/?next=recruitment`);
            const redirectUrl = response.data.url;
            window.location.href = redirectUrl;
        } catch (error) {
            console.error('Erro ao obter URL de redirecionamento:', error);
        }
    }
    
    async function redirectToAdmission() {
        try {
            const response = await http.get(`${process.env.REACT_APP_BASE_URL}auth/ats/login/?next=admission`);
            const redirectUrl = response.data.url;
            window.location.href = redirectUrl;
        } catch (error) {
            console.error('Erro ao obter URL de redirecionamento:', error);
        }
    }

    return (

        <ProtectedRoute>
            <Toast ref={toast} position="top-right" />

            <div className="bg-oval">
                <div className="container">
                    <div className="row formMarginBottom">
                        <div className="col py-3 ">

                            <div className="row mt-3">

                                <div className="col-12 text-default rounded bg-white border-clean">
                                    <div className="pt-3 pb-2 my-2">
                                        <table>
                                            <tbody>
                                                <tr>
                                                    <td className="align-middle">
                                                    {
                                                        company.logo ?
                                                        <>
                                                        <img src={`${company.logo}`} alt="logo" className="img-thumbnail img-fluid rounded-circle border-0" width="50" />
                                                        </>  
                                                        : 
                                                        <>
                                                        <img src={CompanyLogoDefault} alt="logo" className="img-fluid rounded border-0" width="50" />
                                                        </>
                                                    }
                                                    </td>
                                                    <td className="align-middle">
                                                        <div className="font1em ps-2"><span className="fw-bolder h6">{ company.name }</span><br/>Seja bem vindo(a) <span className="fw-bolder">{user.first_name} {user.last_name}</span>!</div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            
                            </div>
                            
                            <div className="row mt-3">

                                <div className="col-md-4 my-2 d-flex flex-column gap-3">

                                    {pendingTransfersCount > 0 && (
                                    <div className="bg-white rounded border-clean p-3">
                                        <div className="fs-6 text-default fw-bold pt-2">
                                            <FontAwesomeIcon icon={solid('list-check')} className="text-green me-2" />
                                            Tarefas Pendentes
                                            {pendingTransfersCount > 0 && (
                                                <span className="float-end badge rounded-pill bg-danger">{pendingTransfersCount}</span>
                                            )}
                                            <hr />
                                        </div>

                                        {pendingTransfersCount > 0 ? (
                                            <>
                                            <table className='table table-borderless border-top'>
                                                <tbody>
                                                {pendingTransfers.slice(0, 5).map((item, index) => (
                                                    <tr key={index} className='cursorPointer border-bottom align-middle'
                                                        onClick={() => navigate(`/career/transfer/${item.employee?.id}/`)}>
                                                        <td>
                                                            <div className="text-green pb-1 fw-semibold small">
                                                                {item.employee?.name || '—'}
                                                            </div>
                                                            <div className="d-flex justify-content-between align-items-center">
                                                                <small className="text-muted">
                                                                    {item.status === 'PC' && 'Aguarda sua revisão'}
                                                                    {item.status === 'PR' && 'Aguarda sua configuração'}
                                                                    {item.status === 'PF' && 'Aguarda sua aprovação'}
                                                                </small>
                                                                <small className="text-muted">
                                                                    {moment(item.created).fromNow()}
                                                                </small>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                                </tbody>
                                            </table>
                                            {pendingTransfersCount > 5 && (
                                                <div className="text-center">
                                                    <small className="text-muted">+{pendingTransfersCount - 5} mais</small>
                                                </div>
                                            )}
                                            </>
                                        ) : (
                                            <p className="text-muted small">Nenhuma tarefa pendente</p>
                                        )}
                                    </div>
                                    )}

                                    {pendingPerformanceSteps.length > 0 && (
                                    <div className="bg-white rounded border-clean p-3">
                                        <div className="fs-6 text-default fw-bold pt-2">
                                            <FontAwesomeIcon icon={solid('clipboard-check')} className="text-green me-2" />
                                            Avaliações Pendentes
                                            <span className="float-end badge rounded-pill bg-danger">{pendingPerformanceSteps.length}</span>
                                            <hr />
                                        </div>
                                        <table className='table table-borderless border-top'>
                                            <tbody>
                                            {pendingPerformanceSteps.slice(0, 5).map((item, index) => (
                                                <tr key={index} className='cursorPointer border-bottom align-middle'
                                                    onClick={() => window.location.href = item.link}>
                                                    <td>
                                                        <div className="text-green pb-1 fw-semibold small">
                                                            {item.title}
                                                            {item.assess_who_name && (
                                                                <span className="text-muted fw-normal"> · {item.assess_who_name}</span>
                                                            )}
                                                        </div>
                                                        <div className="d-flex justify-content-between align-items-center">
                                                            <small className="text-muted">{item.assessment_title}</small>
                                                            <small className={`fw-semibold ${new Date(item.due_date) < new Date() ? 'text-danger' : 'text-muted'}`}>
                                                                {moment(item.due_date).format('DD/MM/YY')}
                                                            </small>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                            </tbody>
                                        </table>
                                        {pendingPerformanceSteps.length > 5 && (
                                            <div className="text-center">
                                                <small className="text-muted">+{pendingPerformanceSteps.length - 5} mais</small>
                                            </div>
                                        )}
                                    </div>
                                    )}

                                    <div className="bg-white rounded border-clean p-3">
                                        <div className="fs-6 text-default fw-bold pt-2">
                                            <FontAwesomeIcon icon={solid('inbox')} className="text-green me-2" /> Mensagens <span className="float-end badge rounded-pill bg-warning">{messageCount}</span>
                                            <hr />
                                        </div>

                                        {
                                            messageCount > 0 ?
                                            <>
                                            <table className='table table-borderless thover border-top'>
                                                <tbody>
                                            {
                                                messageList.results.slice(0, 5).map((item, index) => 
                                                <tr key={index} className='cursorPointer border-bottom align-middle' onClick={() => { seeMessage(item)}} >
                                                    
                                                    <td>
                                                        <div className="text-green pb-2">
                                                            <span className={`${ item.read_at ? 'fw-normal' : 'fw-bold'}`}>{item.title}</span>
                                                        </div>
                                                        <div className="row px-0 lh-sm">
                                                            <div className="col">
                                                                <small className="text-grey">
                                                                    <span className="fw-semibold">De:</span><br/>{item.sender.fullName}
                                                                </small>
                                                            </div>
                                                            <div className="col text-end">
                                                                <small className="text-grey">
                                                                    <span className="fw-semibold text-white">Em:</span><br/>{moment(item.created_at).fromNow()}
                                                                </small>
                                                            </div>
                                                        </div>
                                                        
                                                    </td>
                                                    
                                                </tr>
                                                )
                                            }
                                                </tbody>
                                            </table>
                                            <div className="text-center">
                                                <a href="/messages/inbox/" className="btn btn-sm btn-success btn-rounded px-4 font095" >Ver todas</a>
                                            </div>
                                            </>
                                            :
                                            <>
                                            <p>Sem mensagens ainda</p>
                                            </>
                                        }
                                    </div>

                                    {canAccess && canAccess.birthdays && upcomingBirthdays.length > 0 && (
                                    <div className="bg-white rounded border-clean p-3">
                                        <div className="fs-6 text-default fw-bold pt-2">
                                            <FontAwesomeIcon icon={solid('cake-candles')} className="text-green me-2" />
                                            <a href="/aniversarios/" className="text-decoration-none text-default">
                                                Próximos Aniversários
                                            </a>
                                            <hr />
                                        </div>
                                        <table className='table table-borderless border-top'>
                                            <tbody>
                                            {upcomingBirthdays.slice(0, 5).map((emp, i) => (
                                                <tr key={i} className='border-bottom align-middle'>
                                                    <td>
                                                        <div className="text-green pb-1 fw-semibold small">
                                                            {emp.name}
                                                            {emp.is_today && <span className="ms-1">🎂</span>}
                                                        </div>
                                                        <div className="d-flex justify-content-between">
                                                            <small className="text-muted">{emp.position}</small>
                                                            <small className="text-default fw-bold">
                                                                {emp.birthday_day}/{emp.birthday_month}
                                                            </small>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                            </tbody>
                                        </table>
                                        <div className="text-center">
                                            <a href="/aniversarios/" className="btn btn-sm btn-success btn-rounded px-4 font095">
                                                Ver calendário
                                            </a>
                                        </div>
                                    </div>
                                    )}

                                    {canAccess && canAccess.company_anniversaries && upcomingAnniversaries.length > 0 && (
                                    <div className="bg-white rounded border-clean p-3">
                                        <div className="fs-6 text-default fw-bold pt-2">
                                            <FontAwesomeIcon icon={solid('building')} className="text-green me-2" />
                                            <a href="/aniversarios/" className="text-decoration-none text-default">
                                                Aniversários de Empresa
                                            </a>
                                            <hr />
                                        </div>
                                        <table className='table table-borderless border-top'>
                                            <tbody>
                                            {upcomingAnniversaries.slice(0, 5).map((emp, i) => (
                                                <tr key={i} className='border-bottom align-middle'>
                                                    <td>
                                                        <div className="text-green pb-1 fw-semibold small">
                                                            {emp.name}
                                                            {emp.is_today && <span className="ms-1">🏢</span>}
                                                        </div>
                                                        <div className="d-flex justify-content-between">
                                                            <small className="text-muted">{emp.position}</small>
                                                            <small className="text-default fw-bold">
                                                                {emp.hire_day}/{emp.hire_month} · {emp.years_in_company} ano{emp.years_in_company !== 1 ? 's' : ''}
                                                            </small>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                            </tbody>
                                        </table>
                                        <div className="text-center">
                                            <a href="/aniversarios/" className="btn btn-sm btn-success btn-rounded px-4 font095">
                                                Ver calendário
                                            </a>
                                        </div>
                                    </div>
                                    )}

                                </div>

                                <div className="col my-2">
                                    <div className="container text-center">

                                        <div className="row row-cols-2 row-cols-md-3 row-cols-lg-4 justify-content-center bg-white rounded border-clean pt-3">

                                            <div className="col card border-0">
                                                <div className="card-body text-center dropdown-center">
                                                    <a href="/painel/" onClick={(e) => e.preventDefault()} id="dpm-carreira" className="no-caret text-decoration-none text-default dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                                                        <img src={carreiras} width='60' alt="" />
                                                        <div className="fw-bold pt-2">Carreira</div>
                                                    </a>
                                                    <ul className="dropdown-menu border headerBorder font1em" aria-labelledby="dpm-carreira">
                                                        <li>
                                                            <a href="/my/career/summary/" className="dropdown-item text-default">
                                                                <FontAwesomeIcon icon={solid('user')} className="me-2 text-muted" />
                                                                Ver Perfil
                                                            </a>
                                                        </li>
                                                        <li><hr style={{borderTop: '1px solid #2d60655f', height:'0', margin:'1em 0'}} /></li>
                                                        <li>
                                                            <a href={`/career/feedback/${userEmployee?.id}/`} className="dropdown-item text-default">
                                                                <FontAwesomeIcon icon={solid('comments')} className="me-2 text-muted" />
                                                                Feedbacks
                                                            </a>
                                                        </li>
                                                        <li>
                                                            <a
                                                                href="/painel/"
                                                                className="dropdown-item text-default"
                                                                onClick={(e) => { e.preventDefault(); navigate('/feedback/request/'); }}
                                                            >
                                                                <FontAwesomeIcon icon={solid('paper-plane')} className="me-2 text-muted" />
                                                                Solicitar Feedback
                                                            </a>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>

                            
                                            {
                                                canAccess ?
                                                <>

{
                                                    canAccess.surveys ?
                                                    <>
                                                    <div className="col card border-0">
                                                        <div className="card-body text-center">
                                                            <a href="/painel/" onClick={(e) => e.preventDefault()} id="dpm-pesquisas" className="no-caret text-decoration-none text-default dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                                                                <img src={pesquisas} width='60' alt="" />
                                                                <div className="fw-bold pt-2">Pesquisas</div>
                                                            </a>
                                                            <ul className="dropdown-menu border headerBorder font1em" aria-labelledby="dpm-pesquisas">
                                                                {VerifyPerms(['view_surveytemplate']) && (
                                                                <li>
                                                                    <a href="/survey/" className="dropdown-item text-default">
                                                                        <FontAwesomeIcon icon={solid('chart-pie')} className="me-2 text-muted" />
                                                                        Dashboard
                                                                    </a>
                                                                </li>
                                                                )}
                                                                {VerifyPerms(['view_survey']) && (
                                                                <li>
                                                                    <a href="/survey/list/" className="dropdown-item text-default">
                                                                        <FontAwesomeIcon icon={solid('list')} className="me-2 text-muted" />
                                                                        Lista de Pesquisas
                                                                    </a>
                                                                </li>
                                                                )}
                                                                {VerifyPerms(['view_surveytemplate']) && (
                                                                <li>
                                                                    <a href="/survey/template/list/" className="dropdown-item text-default">
                                                                        <FontAwesomeIcon icon={solid('file-lines')} className="me-2 text-muted" />
                                                                        Ver Templates
                                                                    </a>
                                                                </li>
                                                                )}
                                                                <li><hr style={{borderTop: '1px solid #2d60655f', height:'0', margin:'1em 0'}} /></li>
                                                                <li>
                                                                    <a href="/survey/take/" className="dropdown-item text-default">
                                                                        <FontAwesomeIcon icon={solid('edit')} className="me-2 text-muted" />
                                                                        Responder
                                                                        {pendingSurveysCount > 0 && (
                                                                            <span className="badge rounded-pill bg-warning text-dark ms-1">{pendingSurveysCount}</span>
                                                                        )}
                                                                    </a>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                    </>
                                                    :
                                                    <>
                                                    <div className="col card border-0 filterGrey" style={{opacity: '0.6'}}>
                                                        <div className="card-body text-center">
                                                            <span className="no-caret text-decoration-none text-default">
                                                                <img src={pesquisas} width='60' alt="" />
                                                                <div className="fw-bold pt-2">Pesquisas</div>
                                                            </span>
                                                        </div>
                                                    </div>
                                                    </>
                                                }

                                                {
                                                    canAccess.recruiting ?
                                                    <>
                                                    <div className="col card border-0">
                                                        <div className="card-body text-center">
                                                            <a href="/painel/" id="dpm-recrut" className="no-caret text-decoration-none text-default" onClick={(e) => { e.preventDefault(); redirectToRecruitment(); }}>
                                                                <img src={recrutamento} width='60' alt="" />
                                                                <div className="fw-bold pt-2">Recrutamento</div>
                                                            </a>
                                                        </div>
                                                    </div>
                                                    </>
                                                    :
                                                    <>
                                                    <div className="col card border-0 filterGrey" style={{opacity: '0.6'}}>
                                                        <div className="card-body text-center">
                                                            <span className="no-caret text-decoration-none text-default">
                                                                <img src={recrutamento} width='60' alt="" />
                                                                <div className="fw-bold pt-2">Recrutamento</div>
                                                            </span>
                                                        </div>
                                                    </div>
                                                    </>
                                                }

                                                {
                                                    canAccess.onboarding ?
                                                    <>
                                                    <div className="col card border-0">
                                                        <div className="card-body text-center">
                                                            <a href="/painel/" id="dpm-adminss" onClick={(e) => { e.preventDefault(); redirectToAdmission(); }} className="no-caret text-decoration-none text-default">
                                                                <img src={admissao} width='60' alt="" />
                                                                <div className="fw-bold pt-2">Admissão</div>
                                                            </a>
                                                        </div>
                                                    </div>
                                                    </>
                                                    :
                                                    null
                                                }

                                                {
                                                    canAccess.goals ?
                                                    <>
                                                    <div className="col card border-0">
                                                        <div className="card-body text-center dropdown-center">
                                                            <a href="/painel/" onClick={(e) => e.preventDefault()} id="dpm-metas" className="no-caret text-decoration-none text-default dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                                                                <img src={metas} width='60' alt="" />
                                                                <div className="fw-bold pt-2">Metas e Objetivos</div>
                                                            </a>
                                                            <ul className="dropdown-menu border headerBorder font1em" aria-labelledby="dpm-metas">
                                                                <li>
                                                                    <a href="/my/goals/"  className="dropdown-item text-default">
                                                                        Minhas Metas
                                                                    </a>
                                                                </li>
                                                                {
                                                                    isManager ?
                                                                    <li>
                                                                        <a href="/my/team/goals/"  className="dropdown-item text-default">
                                                                            Minha Equipe
                                                                        </a>
                                                                    </li>
                                                                    : null
                                                                }
                                                                
                                                                {
                                                                    VerifyPerms(['view_goalplan']) ?
                                                                    <>
                                                                    <li>
                                                                        <a href="/goal/plan/"  className="dropdown-item text-default">
                                                                            Metas Organizacionais
                                                                        </a>
                                                                    </li>
                                                                    </>
                                                                    : null
                                                                }
                                                            </ul>
                                                        </div>
                                                    </div>
                                                    </>
                                                    :
                                                    <>
                                                    <div className="col card border-0 filterGrey" style={{opacity: '0.6'}}>
                                                        <div className="card-body text-center">
                                                            <span className="no-caret text-decoration-none text-default">
                                                                <img src={metas} width='60' alt="" />
                                                                <div className="fw-bold pt-2">Metas Organizacionais</div>
                                                            </span>
                                                        </div>
                                                    </div>
                                                    </>
                                                }

                                                {
                                                    canAccess.performance ?
                                                    <>
                                                    <div className="col card border-0">
                                                        <div className="card-body text-center dropdown-center">
                                                            <a href="/painel/" onClick={(e) => e.preventDefault()} id="dpm-perfor" className="no-caret text-decoration-none text-default dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                                                                <img src={performance} width='60' alt="" />
                                                                <div className="fw-bold pt-2">Performance</div>
                                                            </a>
                                                            <ul className="dropdown-menu border headerBorder font1em" aria-labelledby="dpm-perfor">
                                                                {
                                                                    VerifyPerms(['add_performancereview']) || rootUser ?
                                                                    <>
                                                                    <li>
                                                                        <a href="/create/performance-review-all/"  className="dropdown-item text-default">
                                                                            <FontAwesomeIcon icon={solid('chevron-right')} className="me-1" /> Criar Para Gestor
                                                                        </a>
                                                                    </li>
                                                                    {
                                                                        VerifyPerms(['add_performancetemplate']) || rootUser ?
                                                                        <li>
                                                                            <a href="/create/performance-template/"  className="dropdown-item text-default">
                                                                                <FontAwesomeIcon icon={solid('chevron-right')} className="me-1" /> Criar Ciclo (Múltiplos)
                                                                            </a>
                                                                        </li>
                                                                        : null
                                                                    }
                                                                    <li><hr style={{borderTop: '1px solid #2d60655f', height:'0', margin:'1em 0'}} /></li>
                                                                    </>
                                                                    : null
                                                                }
                                                                {
                                                                    isManager ?   
                                                                    <li>
                                                                        <a href="/my/team/performance/"  className="dropdown-item text-default">
                                                                            Minha Equipe
                                                                        </a>
                                                                    </li>
                                                                    : null
                                                                }
                                                                <li>
                                                                    <a href={`/career/performance/${userEmployee?.id}/`}  className="dropdown-item text-default">
                                                                        Minha Performance
                                                                    </a>
                                                                </li>

                                                                {
                                                                    VerifyPerms(['add_performancereview']) || rootUser ?
                                                                    <React.Fragment>
                                                                    <li><hr style={{borderTop: '1px solid #2d60655f', height:'0', margin:'1em 0'}} /></li>
                                                                    <li>
                                                                        <a href="/performance-template/list/"  className="dropdown-item text-default">
                                                                            Ciclos de Avaliações
                                                                        </a>
                                                                    </li>
                                                                    <li>
                                                                        <a href="/performance-review/list/"  className="dropdown-item text-default">
                                                                            Lista de Avaliações
                                                                        </a>
                                                                    </li>
                                                                    </React.Fragment>
                                                                    : null
                                                                }
                                                                
                                                                {
                                                                    VerifyPerms(['add_performancematrix']) || rootUser ?
                                                                    <React.Fragment>
                                                                    <li><hr style={{borderTop: '1px solid #2d60655f', height:'0', margin:'1em 0'}} /></li>
                                                                    <li>
                                                                        <a href="/performance/general/matrix/"  className="dropdown-item text-default">
                                                                            Matriz 9Box
                                                                        </a>
                                                                    </li>
                                                                    <li>
                                                                        <a href="/performance/calibration/"  className="dropdown-item text-default">
                                                                            Comitê de Calibração
                                                                        </a>
                                                                    </li>
                                                                    </React.Fragment>
                                                                    : null
                                                                }
                                                            </ul>
                                                        </div>
                                                    </div>
                                                    </>
                                                    :
                                                    <>
                                                    <div className="col card border-0 filterGrey" style={{opacity: '0.6'}}>
                                                        <div className="card-body text-center">
                                                            <span className="no-caret text-decoration-none text-default">
                                                                <img src={performance} width='60' alt="" />
                                                                <div className="fw-bold pt-2">Performance</div>
                                                            </span>
                                                        </div>
                                                    </div>
                                                    </>
                                                }
                                                </>
                                                :
                                                <>
                                                Carregando...
                                                </>
                                            }

                                            {canAccess && canAccess.compensation && (
                                            <div className="col card border-0">
                                                <div className="card-body text-center dropdown-center">
                                                    <a href="/painel/" onClick={(e) => e.preventDefault()} id="dpm-remu" className="no-caret text-decoration-none text-default dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                                                        <img src={cargosSalarios} width='60' alt="" />
                                                        <div className="fw-bold pt-2">Cargos & Salários</div>
                                                    </a>
                                                    <ul className="dropdown-menu border headerBorder font1em" aria-labelledby="dpm-remu">
                                                        <li>
                                                            <a href="/cargos-salarios/" className="dropdown-item text-default">
                                                                Dashboard
                                                            </a>
                                                        </li>
                                                        <li>
                                                            <a href="/cargos-salarios/quadro/" className="dropdown-item text-default">
                                                                Quadro de Cargos
                                                            </a>
                                                        </li>
                                                        <li>
                                                            <a href="/cargos-salarios/registrar-salarios/" className="dropdown-item text-default">
                                                                Registrar salários
                                                            </a>
                                                        </li>
                                                        <li>
                                                            <a href="/cargos-salarios/mapa-calor/" className="dropdown-item text-default">
                                                                Mapa de Calor
                                                            </a>
                                                        </li>
                                                        <li>
                                                            <a href="/cargos-salarios/comparar-estruturas/" className="dropdown-item text-default">
                                                                Comparar Estruturas
                                                            </a>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            )}
                                            
                                            {
                                                VerifyPerms(['view_companybi']) ?
                                            
                                                <div className="col card border-0">
                                                    <div className="card-body text-center">
                                                        <a href="/company/reports/" className="text-decoration-none text-default">
                                                            <img src={indicadores} width='60' alt="" />
                                                            <p className="fw-bold pt-2">Indicadores</p>
                                                        </a>
                                                    </div>
                                                </div>
                                                : null
                                            }

                                            <div className="col card border-0">
                                                <div className="card-body text-center">
                                                    <a href="/my/org-chart/" className="text-decoration-none text-default">
                                                        <img src={organograma} width='60' alt="" />
                                                        <p className="fw-bold pt-2">Organograma</p>
                                                    </a>
                                                </div>
                                            </div>

                                            {canAccess && canAccess.birthdays && (
                                            <div className="col card border-0">
                                                <div className="card-body text-center">
                                                    <a href="/aniversarios/" className="text-decoration-none text-default">
                                                        <img src={birthdays} width='60' alt="" />
                                                        <p className="fw-bold pt-2">Aniversários</p>
                                                    </a>
                                                </div>
                                            </div>
                                            )}


                                            <div className="col card border-0">
                                                <div className="card-body text-center dropdown-center">
                                                    <a href="/painel/" onClick={(e) => e.preventDefault()} id="dpm-config" className="no-caret text-decoration-none text-default dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                                                        <img src={configs} width='60' alt="" />
                                                        <div className="fw-bold pt-2">Configurações</div>
                                                    </a>
                                                    <ul className="dropdown-menu border headerBorder font1em" aria-labelledby="dpm-config">
                                                        <li>
                                                            <a href="/settings/edit-user/"  className="dropdown-item text-default">
                                                                Meus Dados
                                                            </a>
                                                        </li>
                                                        {
                                                            VerifyPerms(['view_companygroup', 'add_companygroup', 'change_companygroup', 'delete_companygroup']) ?

                                                            <li>
                                                                <a href="/settings/perms-management/"  className="dropdown-item text-default">
                                                                    Grupos e Permissões
                                                                </a>
                                                            </li>

                                                            : null
                                                        }
                                                        {
                                                            VerifyPerms(['view_userprofile', 'add_userprofile', 'change_userprofile', 'delete_userprofile']) ?

                                                            <li>
                                                                <a href="/settings/users-management/"  className="dropdown-item text-default">
                                                                    Colaboradores
                                                                </a>
                                                            </li>

                                                            : null
                                                        }
                                                        {
                                                            VerifyPerms(['change_company', 'change_companyconfig']) ?
                                                            <li>
                                                                <a href="/settings/edit-company/"  className="dropdown-item text-default">
                                                                    Gestão Empresa
                                                                </a>
                                                            </li>
                                                            : null
                                                            
                                                        }
                                                    </ul>
                                                </div>
                                            </div>

                                        </div>

                                    </div>
                                    
                                </div>

                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
        </ProtectedRoute>

    )
}